// Copyright (c) 2016 Deere & Company

import actions from '../actions-list';

export const increaseBusyCounter = () => ( {
    type: actions.INCREASE_BUSY_COUNTER,
} );

export const decreaseBusyCounter = () => ( {
    type: actions.DECREASE_BUSY_COUNTER,
} );

export const resetBusyCounter = () => ( {
    type: actions.RESET_BUSY_COUNTER,
} );
